<template>
  <div class="about">
    <button type="primary" text="确定" @click="toScan">跳转</button>
    <div>
      <p>查询参数值: {{ queryParam }}</p>
    </div>
  </div>
</template>
<script>
import wx from "weixin-js-sdk";
export default {
  data() {
    return {
      dataId: "",
      num: 0,
      queryParam: ''
    };
  },
  mounted() {
    this.fetchQueryParams();
  },
  methods: {
    toScan() {
      let getENV = false;
      wx.miniProgram.getEnv(function (res) {
        getENV = res.miniprogram;
      });

      if (!getENV) return;
      wx.miniProgram.navigateTo({
        url: "/pages/scan/scan",
      });
    },
    fetchQueryParams() {
      const params = new URLSearchParams(window.location.search);
      this.queryParam = params.get("scan"); // 替换 'yourParamName' 为你的查询参数名
      console.log(this.queryParam); // 输出查询参数值
    },
  },
};
</script>

<style lang="scss" scoped>
button {
  width: 100px;
  height: 40px;
  background-color: #409eff;
  color: #fff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}
</style>
